
/**
 * 뉴스 출처 정보
 */
export type NewsResponseSource = {
  name?: string;
  url?: string;
};
